import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTaskBlocks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('operation/task-block-components', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTaskBlock(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`operation/task-block-components/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteTaskBlock(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`operation/task-block-components/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
